import type { LGA } from "newui/features/Company/types";
import type { CommonLookupResponse } from "newui/store/tanstack-base";
import { useCommonLookup } from "newui/store/tanstack-base";
import { fetchLGAs } from "../company-api";

export const useLGAs = (): CommonLookupResponse<LGA> => {
	return useCommonLookup<LGA>("lgas", fetchLGAs);
};
